export function isFunction(arg) {
  return typeof arg === 'function' || arg instanceof Function;
}